import Dictionary from "./Dictionary";
import './App.css';

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">
          <h3>Dictionary</h3>
        </header>
        <main>
          <Dictionary defaultKeyword="alien" />
        </main>
        <footer className="App-footer">
          <small>Coded by Ginger Napoleon with SheCodes</small>
        </footer>
      </div>
    </div>
  );
}
